import { Center, Image } from "@mantine/core";

function Logo() {
  return (
    <Image
      mt="md"
      maw={300}
      src="https://centeridentity.com/centeridentitystatic/center-identity-logo.png"
    />
  );
}

export default Logo;
